"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.validation.providerRequired': 'Dostawca płatności jest wymagany',
    'payment.validation.amountRequired': 'Prawidłowa kwota jest wymagana',
    'payment.validation.currencyRequired': 'Waluta jest wymagana',
};
